module.exports = __webpack_public_path__ + "static/media/convidado black.dff7f894.svg";